import React, { Fragment } from "react";
import { InputLabel, Grid, Input } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import inputComponentMask from "lib/inputMask";
import ViewOnlyField from "components/Global/Fields/ViewOnlyField";

const styles = theme => ({
  label: {
    fontWeight: "bold",
    color: "black"
  }
});

class GridTextInput extends React.Component {
  render() {
    const { classes, theme } = this.props;

    return (
      this.props.shouldShow && (
        <>
          <Grid item xs={3}>
            <InputLabel className={this.props.classes.label} htmlFor={this.props.name}>
              {this.props.label}
            </InputLabel>
          </Grid>
          <Grid item xs={4}>
            {!this.props.isEditing &&
              <ViewOnlyField value={this.props.value} mask={this.props.mask} />}

            {this.props.isEditing &&
              <Input
                disabled={!this.props.isEditing}
                fullWidth
                type={this.props.type || "text"}
                name={this.props.name}
                value={this.props.value}
                onChange={this.props.onChange}
                inputComponent={inputComponentMask({
                  mask: this.props.mask
                })}
              />}
          </Grid>
        </>
      )
    );
  }
}

export default withStyles(styles, { withTheme: true })(GridTextInput);
